var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"continer"},[_c('ul',[_c('li',[_c('p',[_vm._v(" "+_vm._s(this.projectList.content)+" ")])])])])}
var staticRenderFns = []

export { render, staticRenderFns }